export default __webpack_public_path__ + "static/media/bunnycorner1.3a471ebe.png";